import { render, staticRenderFns } from "./local-presence-upgrade.vue?vue&type=template&id=425dbcb8"
import script from "./local-presence-upgrade.vue?vue&type=script&lang=js"
export * from "./local-presence-upgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports